import React from "react";
import { Grid } from "@mui/material";
import sliderImage1 from "../../assets/images/SliderImage1.png";
import sliderImage2 from "../../assets/images/SliderImage2.png";
import sliderImage3 from "../../assets/images/SliderImage3.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./SliderAuth.css"



const SliderAuth = () => {
    var settings = {
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        fade: true,
        cssEase: "linear",
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: false,
        pauseOnFocus: false,
    };
    const sliderContent = [
        {
            img: sliderImage1,
            title1: "Innovative Solutions,",
            title2: "Reliable Connections for a Lifetime",
            disc: "A comprehensive offering meeting worlds electrification needs",
        },
        {
            img: sliderImage2,
            title1: "Innovative Solutions,",
            title2: "Reliable Connections for a Lifetime",
            disc: "A comprehensive offering meeting worlds electrification needs",
        },
        {
            img: sliderImage3,
            title1: "Innovative Solutions,",
            title2: "Reliable Connections for a Lifetime",
            disc: "A comprehensive offering meeting worlds electrification needs",
        },
    ];

    return (
        <>
            <Grid item xs={12} md={7} lg={8} className="slider-wrapper" >
                <div className="slider-container">
                    <Slider {...settings}>
                        {sliderContent.map((sliderdetails, index) => (
                            <div className="single-slide" key={index}>
                                <img src={sliderdetails.img} alt="banner" />
                                <div className="overlaySlider"></div>
                            </div>
                        ))}
                    </Slider>

                </div>
            </Grid>
        </>
    )
}

export default SliderAuth;